<template>
  <e-form v-model="isFormValid" class="d-flex flex-column flex-grow-1" @submit="submitForm">
    <e-input v-model="form.lastName" :rules="[required()]" label="Фамилия" class="mb-4" />
    <e-input v-model="form.name" :rules="[required()]" label="Имя" class="mb-4" />
    <e-input v-model="form.middleName" label="Отчество" class="mb-4" />
    <phone-field v-model="form.phoneNumber" :rules="[required()]" class="mb-10" />

    <e-btn :loading="isLoading" variant="primary" type="submit" class="d-block mx-auto mt-auto">
      Завершить регистрацию</e-btn
    >

    <e-btn variant="link" class="mx-auto mt-2 mt-md-6 mb-4" @click="logout">Выйти из учетной записи</e-btn>
  </e-form>
</template>

<script lang="ts" setup>
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import PhoneField from '@/core/components/fields/PhoneField.vue';
import { EBtn, EForm, EInput } from '@/core/components/ui';
import { useServices } from '@/core/composables/services';
import { RouteNames } from '@/core/plugins/router/routeNames';
import { clearPhoneFormat } from '@/core/utils/string';
import { required } from '@/core/utils/validation';
import { useAuthStore } from '@/parts/auth/store/auth';

const $router = useRouter();
const { $auth } = useServices();
const { updateProfile, getProfile } = useAuthStore();

const form = ref({
  name: '',
  middleName: null,
  lastName: '',
  phoneNumber: '',
});

const isLoading = ref(false);

const isFormValid = ref(false);

const submitForm = async () => {
  if (!isFormValid.value) {
    return;
  }

  isLoading.value = true;

  try {
    const result = await updateProfile({
      name: form.value.name,
      middleName: form.value.middleName,
      lastName: form.value.lastName,
      phoneNumber: clearPhoneFormat(form.value.phoneNumber),
    });

    if (!result?.errors) {
      await getProfile(true);

      sessionStorage.setItem('isFirstVisit', '1');

      await $router.push({
        name: RouteNames.SignIn,
      });
    }
  } finally {
    isLoading.value = false;
  }
};

const logout = () => {
  $auth.logout();
};
</script>
